import { css, injectGlobal } from '@emotion/css';
import colors from '@/theme/colors';

injectGlobal`
  .MuiAutocomplete-popper .MuiAutocomplete-option {
    display: flex !important;
    align-items: stretch !important;
    box-sizing: border-box;
    min-height: 0 !important;
    padding: 0 !important;
    background-color: transparent !important;
  }

  .MuiAutocomplete-popper .MuiAutocomplete-option > * {
    flex: 1 1 auto;
    min-width: 0;
    align-self: stretch;
    box-sizing: border-box;
    padding: 8px 16px;
  }

  /* Strong focus ring only when Autocomplete sets data-keyboard-list-nav (arrow keys from input).
   * MUI keeps .Mui-focused on the last hovered option after pointer leave. */
  .MuiAutocomplete-popper[data-keyboard-list-nav='true']
    .MuiAutocomplete-option.Mui-focused:not([aria-selected='true'])
    > * {
    background-color: ${colors.prussian100} !important;
    border-left: 3px solid transparent;
    box-shadow: 0 0 0 1px ${colors.white} inset, 0 0 0 3px ${colors.focusOutlineColor} inset !important;
  }

  .MuiAutocomplete-popper .MuiAutocomplete-option.Mui-focused:hover > *,
  .MuiAutocomplete-popper .MuiAutocomplete-option:hover > * {
    background-color: #f7f7f7 !important;
    box-shadow: none !important;
  }

  .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true'] > * {
    background-color: ${colors.platinum} !important;
    border-left: 3px solid ${colors.jungle};
    padding-left: 13px;
  }

  .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true']:hover > * {
    background-color: #f7f7f7 !important;
  }
  .MuiAutocomplete-popper[data-keyboard-list-nav='true']
    .MuiAutocomplete-option.Mui-focused[aria-selected='true']
    > * {
    background-color: ${colors.platinum} !important;
    box-shadow: 0 0 0 1px ${colors.white} inset, 0 0 0 3px ${colors.focusOutlineColor} inset !important;
  }
`;

const styles = {
  root: css`
    .MuiInput-underline:before {
      border-bottom-color: ${colors.charcoal};
    }

    .MuiInput-underline:hover:not(.Mui-disabled):before {
      border-bottom-color: ${colors.prussian} !important;
    }

    .MuiInputBase-root.MuiInput-root.Mui-error:before,
    .MuiInputBase-root.MuiInput-root.Mui-error:hover:not(.Mui-disabled):before,
    .MuiInputBase-root.MuiInput-root.Mui-error:after {
      border-bottom-color: ${colors.dragon} !important;
    }

    .MuiFormHelperText-root {
      & span {
        font-family: 'Montserrat Regular' !important;
        font-size: 0.75rem !important;
        letter-spacing: -0.3px !important;
        line-height: 1.33 !important;
      }
    }
  `,
  required: css`
    .MuiFormLabel-root::after {
      content: '*';
      color: ${colors.dragon};
      margin-left: 2px;
    }
  `,
};

export default styles;
